module.exports = __webpack_public_path__ + "static/media/icon5.397337b2.svg";